<template>
  <div class="box">
    <div class="bd" v-if="item">
      <div class="group">
        <span class="contractNumber" :lines="undefined">合同号：{{item.contractNo}}</span>
        <div class="tagWrap">
          <span class="tag" id="tag-copy" :data-clipboard-text="item.contractNo" :lines="undefined" @click="copy">复制</span>
        </div>
      </div>
      <div class="group" v-if="sfQuoteNo !== undefined && sfQuoteNo !== null ">
      <span class="contractNumber" :lines="undefined" v-if="sfQuoteNo">报价编号：{{sfQuoteNo}}</span>
      <div class="tagWrap">
        <span class="tag" id="tag-copy1" :data-clipboard-text="sfQuoteNo" :lines="undefined" @click="copysfQuoteNo">复制</span>
      </div>
    </div>
      <div class="empty" />
      <div class="container_3" v-if="item.fromEmkt">
        <img :src="emkt.getMerchandiseLabelPath(item)" class="product-label">
        <img v-if="item.merchandiseIcon"
             class="largeIcon"
             :src=baseurl+item.merchandiseIcon
        />
        <img v-else-if="item.categoryId === 20 || item.categoryId === 10"
             class="largeIcon"
             :src=baseurl+emkt.CUSTOMIZE_IMAGE
        />
        <div class="container_2">
                <span class="lentivirus deep-text-color text-overflow-hidden" style="font-size: 12px;" v-if="item._titleList && item._titleList.length > 0" >
                   <span v-for="title in item._titleList">
                     <span v-if="title.valueText && title.valueText !== '-1' && title.value !== '-1'"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span>&nbsp;</span>
                  </span>
                  <span class="gfpPuromycin light-text-color tiny-font text-overflow-hidden" v-if="item._subTitleList && item._subTitleList.length > 0" >
                    <span v-for="(subTitle, index) in item._subTitleList">
                      <span v-if="index !== 0">/</span>
                      <span v-if="subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1' ">{{subTitle.valueText}}</span>
                    </span>
                  </span>
                </span>

            <span class="humanatgnm light-text-color tiny-font text-overflow-hidden" v-if="item._abstractList && item._abstractList.length>0">
                   <span v-for="(abstractTitle, index) in item._abstractList">
                     <span v-if="abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1' && abstractTitle.valueText.TLNo !== undefined"><span v-if="abstractTitle.columnName === 'TVInfo'">{{abstractTitle.valueText.TLNo}}</span><span v-else>{{abstractTitle.valueText}}</span>&nbsp;</span>
                   </span>
                </span>
          </div>

        <span class="word light-text-color">X {{item.quantity}}</span>
      </div>
      <div class="container_3" v-else>
        <img v-if="item.merchandiseIcon"
             class="largeIcon"
             :src=baseurl+item.merchandiseIcon>
        <img v-else-if="item.categoryId === 20 || item.categoryId === 10"
             class="largeIcon"
             :src=baseurl+emkt.CUSTOMIZE_IMAGE>
        <div class="container_2">
          <span class="lentivirus text-overflow-hidden" :lines="undefined">{{item.name}} <span class="gfpPuromycin" :lines="undefined">{{item.TLNo}} {{item.tag1PUBID}} {{item.eu_RID}}</span></span>
          <span class="humanatgnm text-overflow-hidden" :lines="undefined" v-show="item.tax!==''&&item.tax!==undefined">{{item.tax}}/{{item.symbol}}/{{item.nm_ID}}</span>
        </div>
        <span class="word" :lines="undefined">X {{item.quantity}}</span>
      </div>
    </div>
    <div class="bd" style="height: 300px;" v-if="showDefaultImage">
      <img src="/static/img/进展空.png" style="width: 100%;">
    </div>
    <task-progress :type="type" :taskModules="taskModules" :expressOutList="expressOutList" v-else></task-progress>
  </div>
</template>

<script>
  import TaskProgress from './TaskProgress'
  // import $ from 'jquery'
  import Clipboard from 'clipboard'
  export default {
    name: 'ToolProgress',
    components: {
      TaskProgress
    },
    props: {
      type: String,
      progressInfo: Object,
      item: Object,
      sfQuoteNo: null
    },
    data () {
      return {
        isShow: false,
        baseurl: '/emktResources/resocurces/img/merchandise/'
      }
    },
    computed: {
      showDefaultImage () {
        if (!this.progressInfo || !this.progressInfo.contractInfo) {
          return true
        } else if (!this.taskModules || this.taskModules === []) {
          return true
        } else {
          return false
        }
      },
      gtvInfo () {
        if (this.progressInfo.contractInfo.gtvInfo) {
          return this.progressInfo.contractInfo.gtvInfo[0]
        } else {
          return []
        }
      },
      taskModules () {
        if (this.progressInfo.contractInfo.taskModules) {
          return this.progressInfo.contractInfo.taskModules[0]
        } else {
          return []
        }
      },
      expressOutList () {
        if (this.progressInfo.contractInfo.expressOutList) {
          return this.progressInfo.contractInfo.expressOutList
        } else {
          return []
        }
      }
    },
    methods: {
      copy () {
        const clipboard = new Clipboard('#tag-copy')
            // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
        clipboard.on('success', e => {
          this.$weui.toast('复制成功', 1500)
          // $.toast('复制成功')
          clipboard.destroy() // 释放内存
        })
        clipboard.on('error', e => {
          this.$weui.topTips('该浏览器不支持自动复制')
          // $.toast('该浏览器不支持自动复制')
          clipboard.destroy()
        })
      },
      copysfQuoteNo () {
        const clipboard = new Clipboard('#tag-copy1')
            // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
        clipboard.on('success', e => {
          this.$weui.toast('复制成功', 1500)
                // $.toast('复制成功')
          clipboard.destroy() // 释放内存
        })
        clipboard.on('error', e => {
          this.$weui.topTips('该浏览器不支持自动复制')
                // $.toast('该浏览器不支持自动复制')
          clipboard.destroy()
        })
      }
    }
  }
</script>

<style scoped>
  /*.box {*/
  /*  display: flex;*/
  /*  align-items: center;*/
  /*  flex-direction: column;*/
  /*  background-color: #efeef3;*/
  /*  width: 100vw;*/
  /*  margin-top: 15vw;*/
  /*  height: 97vh;*/
  /*  top: 14.93vw;*/
  /*  bottom: 4vw;*/
  /*}*/
  .product-label {
    z-index: 5;
    width: 30px;
    position: absolute;
    top: -15px;
    left: -15px;
  }
  .text-overflow-hidden {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .box {
    display: flex;
    flex-shrink: 0;
    position: relative;
    align-items: center;
    flex-direction: column;
    background-color: #FAFAFA;
    width: 100vw;
    height: 97vh;
    top: 14.93vw;
    bottom: 4vw;
  }
  .bd {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    margin-top: 2.67vw;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 94.67vw;
    height: 29.87vw;
    margin-bottom: 8.67vw;
  }
  .group {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.67vw;
    width: 86.67vw;
    height: 6.13vw;
  }

  .contractNumber {
    opacity: 1;
    max-width: 72.27vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .tagWrap {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.93vw;
    border-color: rgba(151, 151, 151, 1);
    padding-right: 2.4vw;
    padding-left: 2.4vw;
    height: 6.13vw;
  }

  .tag {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .empty {
    position: relative;
    margin-top: 1.6vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .container_3 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 15px;
    width: 86.93vw;
    height: 13.87vw;
  }

  .gfpPuromycin {
    top: 2.4vw;
    left: 21.07vw;
    opacity: 1;
    line-height: 5.33vw;
    white-space: pre;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;

  }

  .container_2 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    width: 60vw;
    height: 13.87vw;
  }

  .lentivirus {
    position: absolute;
    top: 2.4vw;
    opacity: 1;
    line-height: 5.33vw;
    white-space: pre;
    color: #424242;
    font-size: 3.73vw;
    font-weight: 500;
    display: block;
    width: 100%;
  }

  .largeIcon {
    position: relative;
    margin-right: 1.33vw;
    width: 13.87vw;
    height: 13.87vw;
  }

  .humanatgnm {
    position: relative;
    opacity: 1;
    margin-top: 6.93vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #929292;
    font-size: 2.67vw;
    font-weight: 400;
    display: block;
    width: 100%;
  }

  .word {
    position: relative;
    opacity: 1;
    line-height: 5.33vw;
    white-space: pre;
    color: #929292;
    font-size: 2.67vw;
    font-weight: 400;
  }



</style>



// WEBPACK FOOTER //
// ToolProgress.vue?80f07542